import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { UpdateOriginalWebUrlLinkDataStatusResponseActionPayload } from '../types';
import type { Action } from 'redux';

const UpdateOriginalWebUrlLinkDataStatus = new ReduxAsyncAction<
  'UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS',
  number,
  UpdateOriginalWebUrlLinkDataStatusResponseActionPayload
>('UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS');

UpdateOriginalWebUrlLinkDataStatus.registerRequest(async (originalWebUrlLinkDataStatus: number) => {
  return { originalWebUrlLinkDataStatus };
});

export const UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS = UpdateOriginalWebUrlLinkDataStatus.actionNamespaceConstants;

export const updateOriginalWebUrlLinkDataStatus = UpdateOriginalWebUrlLinkDataStatus.request;

export type UpdateOriginalWebUrlLinkDataStatusResponseAction = Action<
  typeof UPDATE_ORIGINAL_WEB_URL_LINK_DATA_STATUS.response
> & { data: UpdateOriginalWebUrlLinkDataStatusResponseActionPayload };
